import React, { useState } from "react";

import styles from "./styles/History.module.scss";
import ContentContainer from "Components/Container/ContentContainer";
import ActiveComponent from "./components/ActiveComponent";
import PendingComponent from "./components/PendingComponent";
import CompletedComponent from "./components/CompletedComponent";

const HistoryScreen: React.FC = () => {
  const [activeTab, setActiveTab] = useState("Active");

  const tabs = [
    { id: "Pending", label: "Pending", content: <PendingComponent /> },
    { id: "Active", label: "Active", content: <ActiveComponent /> },
    { id: "Completed", label: "Completed", content: <CompletedComponent /> },
  ];

  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
  };

  return (
    <ContentContainer
      classes={`${styles.History}`}
      hasBoxShadow={true}
      style={{ minWidth: "280px" }}
    >
      <div
        className={`d-flex flex-wrap flex-sm-nowrap justify-content-center justify-content-sm-between ${styles.tabBar}`}
      >
        {tabs.map((tab) => (
          <span
            key={tab.id}
            className={`${activeTab === tab.id ? styles.active : ""}`}
            onClick={() => handleTabClick(tab.id)}
          >
            {tab.label}
          </span>
        ))}
      </div>
      <div className={`${styles.tabContent}`}>
        {tabs.find((tab) => tab.id === activeTab)?.content}
      </div>
    </ContentContainer>
  );
};

export default HistoryScreen;
